import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Observable } from 'rxjs';
import { KeyboardShortcut } from '../models/keyboard-shortcut.model';


@Injectable({ providedIn: 'root' })
export class KeyboardShortcutSdk extends SdkBase {

	constructor(
		injector: Injector) {
		super(injector);
	}

	public get(isMacOS: boolean): Observable<KeyboardShortcut[]> {
		return this.makeHttpRequest<KeyboardShortcut[]>('get', `api2/keyboardshortcut/${isMacOS}`);
	}
}

